import React from 'react';
import PropTypes from 'prop-types';
import Button from 'relements/build/esm/ui/button';

import { userHasPermission, permissionErrorAlert } from '@src/actions/_utils';
import { PERMISSION_LEVELS } from '@src/const';
import CodeEditor from '@src/components/CodeEditor';
import { createAlert } from 'actions/BotActions';
import { AlertTypes } from 'constants/MogamboConstants';

import { fetchDynamicMessage, saveDynamicMessage } from './API/api';
import styles from './dynamicMessage.scss';

class DynamicMessage extends React.Component {
  constructor() {
    super();

    this.state = {
      hasViewPermission: userHasPermission(
        PERMISSION_LEVELS.VIEW_BUSINESS_DYNAMIC_MESSAGE
      ),
      hasEditPermission: userHasPermission(
        PERMISSION_LEVELS.EDIT_BUSINESS_DYNAMIC_MESSAGE
      ),
      codeEditorActive: false,
      code: '',
    };
  }

  componentDidMount() {
    const { hasViewPermission, hasEditPermission } = this.state;

    if (hasViewPermission || hasEditPermission) {
      this._fetchEditorData(this.props.businessId);
    }
  }

  componentDidUpdate(prevProps) {
    const { hasViewPermission, hasEditPermission } = this.state;

    if (
      prevProps.businessId !== this.props.businessId &&
      (hasViewPermission || hasEditPermission)
    ) {
      this._fetchEditorData(this.props.businessId);
    }
  }

  render() {
    const { hasViewPermission } = this.state;
    return (
      <>
        {hasViewPermission
          ? this._renderCodeEditor()
          : this._renderPermissionError()}
      </>
    );
  }

  _renderPermissionError = () => {
    return (
      <div className={styles.dynamicMessagePermission}>
        You do not have permission to view this.
      </div>
    );
  };

  _renderCodeEditor = () => {
    const { code, codeEditorActive } = this.state;

    if (!codeEditorActive)
      return <Button onClick={this._openEditor}>Open Code Editor</Button>;

    return (
      <CodeEditor
        code={code}
        onSave={this._saveEditor}
        navToMenu={this._closeEditor}
        noRun
        noCustomLogic
      />
    );
  };

  _closeEditor = () => {
    this.setState({ codeEditorActive: false });
  };

  _openEditor = () => {
    this.setState({ codeEditorActive: true });
  };

  _fetchEditorData = businessId => {
    if (!businessId) return;

    fetchDynamicMessage(businessId)
      .then(res => {
        this.setState({ code: res.body.dynamic_message_code || '' });
      })
      .catch(err => {
        console.error(err);
        this.setState({ code: '' });
        createAlert('Failed to fetch data', null, AlertTypes.NEGATIVE);
      });
  };

  _saveEditor = (code, cb) => {
    if (!this.state.hasEditPermission) {
      cb(false);
      return permissionErrorAlert('update dynamic message');
    }

    const data = {
      business_id: this.props.businessId,
      dynamic_message_code: code,
    };

    saveDynamicMessage(data)
      .then(() => {
        this.setState({ code });
        cb(true);
        createAlert('Saved Successfully!', null, AlertTypes.POSITIVE);
      })
      .catch(err => {
        console.error(err);
        cb(false);
        createAlert('Failed to update data', null, AlertTypes.NEGATIVE);
      });
  };
}

DynamicMessage.propTypes = {
  businessId: PropTypes.string,
};

DynamicMessage.defaultProps = {
  businessId: '',
};

export default DynamicMessage;
